import React from "react";
import DeleteModal from "../DeleteModal";

const SubscriptionsTab = ({
  t,
  subscriptions,
  showDropdown,
  toggleDropdown,
  navigate,
  handleReactivateSubscription,
  handleCancelSubscription,
  setShowCancelModal,
  setShowDeleteSubscriptionModal,
  setSubscriptionToDelete,
  handleConfirmDeleteSubscription,
  showDeleteSubscriptionModal,
  showCancelModal,
  showSuccessModal,
  setShowSuccessModal,
}) => {
  return (
    <div className="tab-content">
      <h2 onClick={() => toggleDropdown("subscription")}>
        {t("account.subscriptions")} {showDropdown ? "▼" : "▶"}
      </h2>

      {/* ✅ Only render the section when expanded */}
      {showDropdown && (
        <div className="subscription-section">
          {subscriptions.length > 0 ? (
            subscriptions.map((sub) => (
              <div
                key={sub.id}
                className={`subscription-entry ${
                  !sub.active ? "inactive-subscription" : ""
                }`}
              >
                <p className="subscription-plan">
                  {t("account.subscription_plan")}: {sub.plan}
                </p>
                <p className="subscription-date">
                  {t("account.renewal_date")}: {sub.renewalDate}
                </p>

                {!sub.active ? (
                  <>
                  {/*Add after mvp*/}
                   {/* <button
                      className="reactivate-btn"
                      onClick={handleReactivateSubscription}
                    >
                      {t("account.reactivate_subscription")}
                    </button>*/}
                    <button
                      className="new-subscription-btn"
                      onClick={() => navigate("/pricing")}
                    >
                      {t("account.new_subscription")}
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => {
                        setShowDeleteSubscriptionModal(true);
                        setSubscriptionToDelete(sub.id);
                      }}
                    >
                      {t("account.delete_subscription")}
                    </button>
                  </>
                ) : (
                  <>
                    <button className="upgrade-btn"
                    onClick={() => navigate("/pricing")}
                    >
                      {t("account.upgrade_plan")}
                    </button>
                    <button
                      className="cancel-btn"
                      onClick={() => setShowCancelModal(true)}
                    >
                      {t("account.cancel_subscription")}
                    </button>
                  </>
                )}
              </div>
            ))
          ) : (
            <div>
              <p>{t("account.no_subscriptions")}</p>
              <button
                className="new-subscription-btn"
                onClick={() => navigate("/pricing")}
              >
                {t("account.new_subscription")}
              </button>
            </div>
          )}
        </div>
      )}

      {/* ✅ Delete subscription (glass) */}
      {showDeleteSubscriptionModal && (
        <DeleteModal
          title={t("account.modals.delete_subscription_title")}
          message={t("account.modals.delete_subscription_message")}
          onConfirm={handleConfirmDeleteSubscription}
          onCancel={() => setShowDeleteSubscriptionModal(false)}
          confirmText={t("account.modals.delete_subscription_yes")}
          cancelText={t("account.modals.delete_subscription_no")}
        />
      )}

      {/* ✅ Cancel subscription (reuse same modal component) */}
      {showCancelModal && (
        <DeleteModal
          title={t("account.modals.cancel_subscription_title")}
          message={t("account.modals.cancel_subscription_message")}
          onConfirm={() => {
            handleCancelSubscription();
            setShowCancelModal(false);
          }}
          onCancel={() => setShowCancelModal(false)}
          confirmText={t("account.modals.cancel_subscription_yes")}
          cancelText={t("account.modals.cancel_subscription_no")}
        />
      )}

      {/* Optional success toast/modal */}
      {showSuccessModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowSuccessModal(false)}>
          <div className="modal-card compact">
            <h3 className="modal-title">{t("account.subscription_cancelled_success")}</h3>
            <div className="modal-actions">
              <button className="primary-btn" onClick={() => setShowSuccessModal(false)}>
                {t("account.close")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionsTab;